import React__default from 'react';
import PropTypes from 'prop-types';
import { CardHeader as CardHeader$2 } from './Card.styles.js';

var CardHeader = function CardHeader(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  return React__default.createElement(CardHeader$2, {
    "data-testid": testId
  }, children);
};
CardHeader.propTypes = {
  children: PropTypes.node,
  testId: PropTypes.string
};
var CardHeader$1 = CardHeader;

export { CardHeader$1 as default };
//# sourceMappingURL=CardHeader.js.map
